import { Component, OnInit } from '@angular/core';
import { CatRoles, RUsuariosRoles, User } from '../../entidades/entidades';
import { AuthenticationService } from '../../../app/servicios';
import { RUsuarioNivelesService } from "../../servicios/r-usuario-niveles.service";
import { CatRolesService } from "../../servicios/cat-roles.service";
import { RUsuariosRolesService } from "../../servicios/r-usuarios-roles.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";



@Component({
  selector: 'app-manuales',
  templateUrl: './manuales.component.html',
  styleUrls: ['./manuales.component.css']
})
export class ManualesComponent implements OnInit {
  ocultarProcesando: boolean = true;
  ocultarReporte: boolean = true;
  oculatarSinResultado: boolean = true;

  muestraMensaje = new MuestraMensaje();

  display: boolean = false;
  currentUser: User;
  usuario: any;
  rUsuarioRol: number;
  rolUsuario: string;
  catRoles: CatRoles[];
  rUsuariosRoles: RUsuariosRoles[];
  ManualAdministracion: boolean;
  manualesObject = {
    ManualAdministracion: false,
    ManualCobrosAgua: false,
    ManualCobrosServicios: false,
    ManualVentanilla: false,
    ManualCatalogos: false,
    ManualSeguimientoTramite: false,
    ManualSeguridad: false,
    ManualEjecucionFiscal: false,
    ManualAsignacion: false,
    ManualCuentaMasivo: false,
    ManualEstadoAdeudos: false,
    ManualCaptura: false,
    ManualConvenios: false,
    ManualBloqueoCuentas: false,
    ManualCorreccionPeriodos: false,
    ManualSimulador: false,
    ManualGrupoVulnerables: false,
    ManualCobros: false,
    ManualReportesBitacoras: false,
    ManualDescuentos: false,
    ManualFacturacion: false,
    ManualBitacorasMovimiento: false,
    ManualBusquedaBitacora: false,
    ManualConciliacion: false,
  };

  constructor(private authenticationService: AuthenticationService,
    private rUsuarioNivelesService: RUsuarioNivelesService,
    private catRolesService: CatRolesService,
    private rUsuariosRolesService: RUsuariosRolesService,
  ) {

  }

  ngOnInit() {
    /*this.usuario = this.authenticationService.currentUserValue.id;
    this.muestraManualesUsuario();*/
  }

  async muestraManualesUsuario() {
    try {
      const datoRetorno = await this.rUsuariosRolesService.getAll().toPromise();
      for (let i = 0; i < datoRetorno.length; i++) {
        if (datoRetorno[i].idUsuario == this.usuario) {
          this.rUsuarioRol = datoRetorno[i].idRol;
        }
      }

      const datoRetornoRol = await this.catRolesService.getAll().toPromise();
      for (let i = 0; i < datoRetornoRol.length; i++) {
        if (datoRetornoRol[i].id == this.rUsuarioRol) {
          this.rolUsuario = datoRetornoRol[i].descripcion;
        }
      }
      console.log('Usuario: ', this.usuario, ' , IDROL: ', this.rolUsuario, ' , ROL Actual: ', this.rUsuarioRol);
      switch (this.rolUsuario) {
        case 'ADMINISTRADOR CAJA':
          this.manualesObject.ManualCobrosAgua = true;
          this.manualesObject.ManualCobrosServicios = true;
          this.manualesObject.ManualAdministracion = true;
          this.manualesObject.ManualFacturacion = true;
          this.manualesObject.ManualConciliacion = true;
          break;
        case 'ATENCION USUARIOS':
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualVentanilla = true;
          this.manualesObject.ManualSeguimientoTramite = true;
          break;
        case 'CAJAS':
          this.manualesObject.ManualCobrosAgua = true;
          this.manualesObject.ManualCobrosServicios = true;
          this.manualesObject.ManualAdministracion = true;
          break;
        case 'CAPTURA MASIVA':
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualAsignacion = true;
          this.manualesObject.ManualCaptura = true;
          break;
        case 'CAPTURISTA ESPECIAL':
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualAsignacion = true;
          this.manualesObject.ManualCaptura = true;
          break;
        case 'CAPTURISTAS':
          this.manualesObject.ManualAsignacion = true;
          this.manualesObject.ManualCaptura = true;
          this.manualesObject.ManualEstadoAdeudos = true;
          break;
        case 'CONSULTA':
          this.manualesObject.ManualSeguimientoTramite = true;
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualGrupoVulnerables = true;
          break;
        case 'DIR GENERAL/PRESIDENCIA':
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualAdministracion = true;
          break;
        case 'DIRECCION COMERCIAL':
          this.manualesObject.ManualCuentaMasivo = true;
          this.manualesObject.ManualAsignacion = true;
          this.manualesObject.ManualCaptura = true;
          this.manualesObject.ManualSeguimientoTramite = true;
          this.manualesObject.ManualVentanilla = true;
          this.manualesObject.ManualCorreccionPeriodos = true;
          this.manualesObject.ManualSimulador = true;
          this.manualesObject.ManualGrupoVulnerables = true;
          this.manualesObject.ManualConvenios = true;
          this.manualesObject.ManualCobros = true;
          break;
        case 'JEFE ATENCIÓN A USUARIOS':
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualVentanilla = true;
          this.manualesObject.ManualSeguimientoTramite = true;
          break;
        case 'LIQUIDACIONES 1':
          this.manualesObject.ManualVentanilla = true;
          this.manualesObject.ManualSimulador = true;
          this.manualesObject.ManualGrupoVulnerables = true;
          this.manualesObject.ManualConvenios = true;
          this.manualesObject.ManualCobros = true;
          this.manualesObject.ManualReportesBitacoras = true;
          break;
        case 'LIQUIDACIONES 2':
          this.manualesObject.ManualVentanilla = true;
          this.manualesObject.ManualSimulador = true;
          this.manualesObject.ManualGrupoVulnerables = true;
          this.manualesObject.ManualConvenios = true;
          this.manualesObject.ManualCobros = true;
          this.manualesObject.ManualReportesBitacoras = true;
          break;
        case 'MEDICION Y FACTURACION':
          this.manualesObject.ManualCuentaMasivo = true;
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualAsignacion = true;
          this.manualesObject.ManualCaptura = true;
          this.manualesObject.ManualCorreccionPeriodos = true;
          break;
        case 'MEDICION Y FACTURACION JEFE':
          this.manualesObject.ManualCuentaMasivo = true;
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualAsignacion = true;
          this.manualesObject.ManualCaptura = true;
          this.manualesObject.ManualCorreccionPeriodos = true;
          break;
        case 'RECEPTORIAS OPERAGUA':
          this.manualesObject.ManualCobrosAgua = true;
          this.manualesObject.ManualCobrosServicios = true;
          this.manualesObject.ManualAdministracion = true;
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualGrupoVulnerables = true;
          break;
        case 'SOPORTE TI':
          this.manualesObject.ManualReportesBitacoras = true;
          this.manualesObject.ManualBusquedaBitacora = true;
          this.manualesObject.ManualBitacorasMovimiento = true;
          this.manualesObject.ManualFacturacion = true;
          break;
        case 'EJECUCIÓN FICAL':
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualBloqueoCuentas = true;
          this.manualesObject.ManualEjecucionFiscal = true;
          break;
        case 'FINANZAS':
          this.manualesObject.ManualAdministracion = true;
          break;
        default:
          this.manualesObject.ManualAdministracion = true;
          this.manualesObject.ManualCobrosAgua = true;
          this.manualesObject.ManualCobrosServicios = true;
          this.manualesObject.ManualVentanilla = true;
          this.manualesObject.ManualCatalogos = true;
          this.manualesObject.ManualSeguimientoTramite = true;
          this.manualesObject.ManualSeguridad = true;
          this.manualesObject.ManualEjecucionFiscal = true;
          this.manualesObject.ManualAsignacion = true;
          this.manualesObject.ManualCuentaMasivo = true;
          this.manualesObject.ManualEstadoAdeudos = true;
          this.manualesObject.ManualCaptura = true;
          this.manualesObject.ManualConvenios = true;
          this.manualesObject.ManualBloqueoCuentas = true;
          this.manualesObject.ManualCorreccionPeriodos = true;
          this.manualesObject.ManualSimulador = true;
          this.manualesObject.ManualGrupoVulnerables = true;
          this.manualesObject.ManualCobros = true;
          this.manualesObject.ManualReportesBitacoras = true;
          this.manualesObject.ManualDescuentos = true;
          this.manualesObject.ManualFacturacion = true;
          this.manualesObject.ManualBitacorasMovimiento = true;
          this.manualesObject.ManualBusquedaBitacora = true;
          this.manualesObject.ManualConciliacion = true;
          break;
      }

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }


}
